<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable class="voice_pop single_edit_add"  width="700" >
    <div class="single_input">
      <div class="font_style_set"><span style="color: red">*</span>语音文件名:</div>
      <Input v-model="voiceFileName" placeholder="请输入语音文件名"/>
    </div>
    <div class="single_input">
      <div class="font_style_set"><span style="color: red">*</span>上传语音文件:</div>
      <Upload :action="uploadUrl" style="width: 80%" :on-exceeded-size="handleMaxSize" :show-upload-list="showUpload" :on-format-error="handleFormatError" :on-success="handleSuccess" :on-error="handleFail" :format="format" :max-size="1024*15">
        <Input v-model="voiceFileRoute" readonly="readonly" placeholder="上传语音文件"/>
      </Upload>
    </div>
    <div style="width: 100%;display: flex;">
      <div class="font_style_set"></div>
      <span style="color: red">请上传MP3、WAV格式的语音文件,最大支持15M</span>
    </div>
    <div class="single_input">
      <div class="font_style_set">文件备注:</div>
      <Input v-model="fileRemark" class="input_content" type="textarea"/>
    </div>
    <div class="btn_template" style="padding-top: 37px;">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">确认</Button>
    </div>
  </Modal>
</template>

<script>
    export default {
      name: "VoiceFileEditOrAdd",
      props:{
        showVoiceFileEditOrAdd:Boolean,
        fileName:String,
        fileRoute:String,
        fileId:String,
        remark:String
      },
      data(){
        return{
          model:false,
          showUpload:false,
          voiceFileRoute:'',
          voiceFileName:'',
          fileRemark:'',
          format:['mp3','wav'],
          title:'添加语音文件',
          uploadUrl:this.baseURL+"common/upload.json?type=customizeMusic&companyNo="+localStorage.getItem("companyId"),
        }
      },
      methods:{
        handleMaxSize (file) {
          this.$Modal.info({
            title: '超出文件大小限制',
            content: '文件 ' + file.name + ' 太大，不能超过15M。'
          });
        },
        handleFormatError (file) {
          this.$Modal.info({
            title:'提示',
            content: '文件 ' + file.name + ' 格式不正确，请上传 mp3 或 wav 格式的文件!'
          });
        },
        handleSuccess:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.voiceFileRoute=file.response.obj.absolutePath;
        },
        handleFail:function (error, file) {
          this.$Modal.info({
            title:'失败提示',
            content:file.response.msg
          });
        },
        cancel:function () {
          this.$emit("closeVoiceFileEditOrAdd",false)
        },
        save:function () {
          let that=this;
          if (!this.voiceFileName){
            this.$Message.info("语音文件名不能为空");
            return false;
          }
          if (!this.voiceFileRoute){
            this.$Message.info("请上传语音文件");
            return false;
          }
          let menuId="3_5-4-1";
          if(this.fileId){
            menuId="3_5-4-2";
          }
          let param={
            remark:this.fileRemark,
            voiceFileName:this.voiceFileName,
            voiceFileRoute:this.voiceFileRoute,
            journalType:"CTI配置=>VIP管理=>"+ this.title,
            menuId:menuId,
            id:this.fileId
          };
          this.$http.post("voiceFile/doSave.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Modal.info({
              title:'提示',
              content:that.title+"成功"
            });
            that.$emit("closeVoiceFileEditOrAdd",true)
          })
        }
      },
      watch:{
        showVoiceFileEditOrAdd:function () {
          this.model=this.showVoiceFileEditOrAdd;
          this.voiceFileName=this.fileName;
          this.voiceFileRoute=this.fileRoute;
          this.fileRemark = this.remark;
          this.title='添加语音文件';
          if(this.fileId){
            this.title='编辑语音文件';
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/VoiceFileEditOrAdd.vue